<ng-container *transloco="let t;">
  <div class="card-header">
    <h4 class="card-title font-medium-1">{{ t('Auto renewal on (Dashboard auto renewal on widget title) - Auto renewal on') }}</h4>
  </div>
  <div class="card-body">
    @for(autoRenewalOn of (fetchAutoRenewalOn$ | async)?.data; track autoRenewalOn){
    <div class="transaction-item">
      <div class="media">
        <div class="avatar bg-light-danger rounded">
          <div class="avatar-content">
            <i class="feather font-medium-3 icon-sliders"></i>
          </div>
        </div>
        <div class="media-body">
          <h6 class="transaction-title activity-Links-h6"><a class="activity-Links" [routerLink]="['/contract-control/view/'+autoRenewalOn.contract_control_id+'']">{{autoRenewalOn.contract_control.contract_control_name}}</a></h6>
          <small>{{ autoRenewalOn.contract_control?.category?.category_name }}</small>
        </div>
      </div>
      <div><small class="text-muted">{{ autoRenewalOn.end_date  | dateFormat | async }}</small></div>
    </div>
    } @empty {
    <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
      <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
    </div>
    }
  </div>
</ng-container>